import type { CSSProperties, ReactNode } from 'react'
import { Link } from 'react-router-dom'

type HomepageActionLinkProps = {
  href: string
  className?: string
  style?: CSSProperties
  children: ReactNode
}

export default function HomepageActionLink({
  href,
  className,
  style,
  children,
}: HomepageActionLinkProps) {
  if (href.startsWith('/')) {
    return (
      <Link className={className} to={href} style={style}>
        {children}
      </Link>
    )
  }

  return (
    <a className={className} href={href} style={style}>
      {children}
    </a>
  )
}
